import { useEffect, useState } from "react";
import { Box } from "@mui/material";

import { Filter } from "./Filter";
import { Search } from "./Search";
import { Sort } from "./Sort";

import { useAppDispatch, useAppSelector } from "../../hooks";
import { filterLocations } from "../../redux/features/locationsSlice";

export interface SearchAndFilterLocationsProps {
  boxShadow: () => any;
}

function SearchAndFilterLocations({
  boxShadow,
}: SearchAndFilterLocationsProps) {
  //{ innerRef }: React.MutableRefObject<null>
  const dispatch = useAppDispatch();
  const [query, setQuery] = useState("");
  const [regions, setRegions] = useState<string[]>([]);
  const [states, setStates] = useState<string[]>([]);

  // retrieve list of states from locations in redux, remove duplicates,
  // sort them, and map to structure supported by Filter component
  const STATES_LIST = Array.from(
    new Set(
      useAppSelector((state) =>
        state.locations.opportunities.map((l) => l.core.physicalAddress.state),
      ),
    ),
  )
    .sort()
    .map((s) => {
      return { label: s, value: s };
    });

  useEffect(() => {
    dispatch(filterLocations({ q: query, regions, states }));
  }, [dispatch, query, regions, states]);

  return (
    <Box padding={1} sx={boxShadow} zIndex={1}>
      <Box display="flex" alignItems="center">
        <Search q={query} setQ={setQuery} />
      </Box>
      <Box display="flex" alignItems="center" marginTop={2}>
        {/* <FormGroup>
          <FormControlLabel control={<Checkbox checked={showFavoritesChecked} onChange={handleShowFavoritesChange}/>} label="Favorites Only" />
        </FormGroup> */}
        <Sort />
        <Filter
          name="State"
          state={states}
          setState={setStates}
          values={STATES_LIST}
        />
        <Filter
          name="Region"
          state={regions}
          setState={setRegions}
          values={[
            { label: "Atlantic", value: "21" },
            { label: "Midwest", value: "41" },
            { label: "Northeast", value: "121" },
            { label: "Southeast", value: "101" },
            { label: "Southwest", value: "81" },
            { label: "West", value: "61" },
          ]}
        />
      </Box>
    </Box>
  );
}

export default SearchAndFilterLocations;
